/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../stylesheets/slotEditor.scss';
import SlotEditorItemFlyout from './SlotEditorItemFlyout';
import FieldItem from './FieldItem';
/**
 * The SlotEditorFilterItem component is responsible for the User Interface for a single local filter
 */
class SlotEditorFilterItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFlyoutShown: false
		};
		this.sourceId = this.props.filterItemActionHandler.getDatasourceId();
		this.flyoutTooltipTimer = null;
	}

	componentDidMount() {
		this._initializeDndSupport();
	}

	render() {

		const { filterString, numberOfFilterItems } = this.props;
		return (
			<React.Fragment>
				{this._renderFlyout()}
				<FieldItem
					className="slotEditorItem"
					fieldName={this.props.itemName}
					onKeyUp={ (event) => this.props.a11Y.handleKeyUpForFilterItem(event, this.props.filterItemActionHandler, {
						metadataColumn: this.props.metadataColumn,
						filterId: this.props.itemFilterId
					})}
					onMouseEnterCallBack={this._showFlyout.bind(this)}
					onMouseLeaveCallBack={this._hideFlyout.bind(this)}
					onOpenActionMenu={this._filterItemActionMenu.bind(this)}
					filterInfo={{ filterString, numberOfFilterItems }}
					draggable={false}
					ref={
						fieldItem => {
							if(fieldItem && fieldItem.getDOMNode) {
								this.domNode = fieldItem.getDOMNode();
							}
						}
					}
				/>
			</React.Fragment>
		);
	}

	_initializeDndSupport() {
		this.props.dndManager.then(
			(dndManager) => {
				this._dndManager = dndManager;
			}
		);
	}

	_filterItemActionMenu(){
		this.props.filterItemActionHandler.openFilterItemActionMenu(
			{
				columnId: this.props.itemColumnId,
				filterId: this.props.itemFilterId
			},
			this.domNode,
			{
				attachPoint: '.actionmenu',
				placement: 'bottom auto'	//This string is important. Please see https://github.ibm.com/BusinessAnalytics/vis-slot-editor/pull/43 before changing.
			}
		);
	}

	_renderFlyout() {
		const shouldRenderFlyout = this.state.isFlyoutShown && this.domNode;
		if ( shouldRenderFlyout ) {
			return (
				<SlotEditorItemFlyout
					domNode={this.domNode}
					dashboardApi={this.props.dashboardApi}
					columnId={this.props.itemColumnId}
					sourceId={this.sourceId}
					onClose={this._hideFlyout}
				/>
			);
		}
	}

	_showFlyout = () => {
		// don't show flyout when doing DND because the mui three flyout somehow mess up the drag object(see defect CADBLW-5243)
		// don't show flyout if slot menu is open
		if (this.flyoutTooltipTimer){
			return;
		}
		this.flyoutTooltipTimer = setTimeout( () => {
			if(!this._isDragging() && !this.props.filterItemActionHandler.isFilterActionMenuOpened()) {
				this.setState({
					isFlyoutShown: !this.state.isFlyoutShown
				});
			}
		}, 1000);
	}

	_hideFlyout = () => {
		this.setState({ isFlyoutShown: false });
		if (this.flyoutTooltipTimer){
			clearTimeout(this.flyoutTooltipTimer);
			this.flyoutTooltipTimer = null;
		}
	}

	_isDragging = () => {
		return !!(this._dndManager && this._dndManager.dragObject);
	}
}

SlotEditorFilterItem.propTypes = {
	itemName: PropTypes.string,
	indexInSlot: PropTypes.number,
	filterString: PropTypes.string,
	numberOfFilterItems: PropTypes.any,
	itemColumnId: PropTypes.string,
	metadataColumn: PropTypes.object,
	itemFilterId: PropTypes.string,
	filterItemActionHandler: PropTypes.object.isRequired,
	a11Y: PropTypes.object.isRequired,
	dndManager: PropTypes.object.isRequired,
	dashboardApi: PropTypes.object.isRequired
};

export default SlotEditorFilterItem;



// WEBPACK FOOTER //
// ./src/js/SlotEditorFilterItem.js